export default {
    GET_NOTIFICATIONS: "[zina_flow][notification] get all notification",
    GET_NOTIFICATIONS_SUCCESS: "[zina_flow][notification] get all notification SUCCESS",
    GET_NOTIFICATIONS_FAIL: "[zina_flow][notification] get all notification FAIL",

    UPDATE_PAGINATION: "[zina_flow][notification] update notification pagination",
    CHANGE_PAGE: "[zina_flow][notification] change notification page",
    FILTER_LIST: "[zina_flow][notification] change notification filters",

    TOGGLE_NOTIFICATION_ACTIVE: "[zina_flow][notification] toggle notification active",
    TOGGLE_NOTIFICATION_ACTIVE_SUCCESS: "[zina_flow][notification] toggle notification active SUCCESS",
    TOGGLE_NOTIFICATION_ACTIVE_FAIL: "[zina_flow][notification] toggle notification active FAIL",

    FETCH_ACTIVE_ALERT_SUCCESS: "[zina_flow][notification] fetch active alert SUCCESS",

    SAVE_NOTIFICATION: "[zina_flow][notification] save notification",
    SAVE_NOTIFICATION_SUCCESS: "[zina_flow][notification] save notification SUCCESS",
    SAVE_NOTIFICATION_FAIL: "[zina_flow][notification] save notification FAIL",
    CLEAR_SAVE_ERROR: "[zina_flow][notification] clear save error",

    OPEN_ALERT_VIEWER: "[zina_flow][notification] open alert viewer",
    CLOSE_ALERT_VIEWER: "[zina_flow][notification] close alert viewer"
};
